import { render } from "./SlidePreview.vue?vue&type=template&id=30883359&ts=true"
import script from "./SlidePreview.vue?vue&type=script&lang=ts"
export * from "./SlidePreview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__